// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Label from '../../../components/Label';
import Iconify from '../../../components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
// console.log(PATH_DASHBOARD.user.profile);
const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item'),
};

const generalNav = (menuData) => [
  // {
  //   subheader: 'general',
  //   roles: ['all'],
  //   items: [
  //     {
  //       title: 'dashboard',
  //       roles: ['Administrador', 'Planificador', 'Supervisor', 'Tecnico', 'Recepcion'],
  //       path: `${PATH_DASHBOARD.general.app}`,
  //       icon: ICONS.dashboard,
  //       children: [
  //         {
  //           title: 'dashboard',
  //           path: PATH_DASHBOARD.general.app,
  //           roles: ['Administrador', 'Planificador', 'Supervisor', 'Tecnico', 'Recepcion'],
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   subheader: 'Gestiones',
  //   // subheader: 'Dashboards',
  //   roles: [menuData[0]?.nombrePerfil],
  //   items: menuData?.map((item) => ({
  //     title: item?.nombre,
  //     roles: [item?.nombrePerfil],
  //     path: item?.url,
  //     // icon: ICONS.menuItem,
  //     icon: <Iconify icon={item?.icon} width={30} height={30} />,
  //   })),
  // },

  ...menuData?.map((mod) => ({
    subheader: mod.nombre,
    roles: [mod?.nombrePerfil],
    items: mod?.Menus?.map((item) => ({
      title: item?.nombre,
      roles: [mod?.nombrePerfil],
      path: item?.url,
      // icon: ICONS.menuItem,
      icon: <Iconify icon={item?.icon} width={30} height={30} />,
    })),
  })),
];

const navConfigAdmin = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Dashboards',
    items: [
      { title: 'Mapa General', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      // { title: 'ecommerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      // { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
      // { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'General',
    items: [
      // USER
      {
        title: 'Administración',
        path: PATH_DASHBOARD.cliente.root,
        icon: ICONS.invoice,
        children: [
          {
            title: 'Gestión clientes',
            path: PATH_DASHBOARD.cliente.list,
          },
        ],
      },
    ],
  },
];

const navConfig = (menuData, isAdmin = false) => {
  return generalNav(menuData);
};

export default navConfig;
